export const REGISTRY_KEYS = {
  PLAYER: {
    HP: 'playerHp',
  },
};
